module.exports = __webpack_public_path__ + "img/suzuki-swift-sport.dafb47f1.jpg";